// Drag like Horizon: clicks work unless you actually move.
// We capture AFTER a tiny movement so starting on <a>/<img> is fine.
// Also block native dragstart to avoid ghost image drags.

(() => {
  const roots = document.querySelectorAll('[data-cat-scroller-root]');

  roots.forEach((root) => {
    const track = root.querySelector('[data-drag-scroll]');
    if (!track) return;

    const prevBtn = root.querySelector('[data-cat-prev]');
    const nextBtn = root.querySelector('[data-cat-next]');

    // Stop native image/link drag ghost
    track.addEventListener('dragstart', (e) => e.preventDefault());

    const isMouseOrPen = (e) => e.pointerType === 'mouse' || e.pointerType === 'pen';

    let dragging = false;
    let moved = false;
    let captured = false;

    // rAF state
    let rafId = null;
    let pendingDX = 0;
    let v = 0;            // px/frame
    let lastX = 0;
    let lastT = 0;
    let travel = 0;

    const MOVE_THRESHOLD = 3; // px

    const startRAF = () => { if (!rafId) rafId = requestAnimationFrame(tick); };
    const stopRAF  = () => { if (rafId) cancelAnimationFrame(rafId); rafId = null; };

    const tick = () => {
      if (pendingDX !== 0) {
        track.scrollLeft += pendingDX;
        pendingDX = 0;
      }
      if (!dragging && Math.abs(v) > 0.05) {
        track.scrollLeft += v;
        v *= 0.92;
      } else if (!dragging) {
        stopRAF();
        root.classList.remove('is-dragging');
      }
      if (rafId) rafId = requestAnimationFrame(tick);
    };

    const onPointerDown = (e) => {
      if (!isMouseOrPen(e)) return;

      dragging = true;
      moved = false;
      captured = false;
      travel = 0;

      // No preventDefault here: allow normal clicks if no drag.

      stopRAF();
      v = 0;
      pendingDX = 0;
      lastX = e.clientX;
      lastT = performance.now();
      startRAF();
    };

    const onPointerMove = (e) => {
      if (!dragging || !isMouseOrPen(e)) return;

      const nowX = e.clientX;
      const nowT = performance.now();
      const dx = lastX - nowX;                // +dx scrolls right
      const dt = Math.max(1, nowT - lastT);

      travel += Math.abs(dx);

      // Crossed threshold → begin drag formally
      if (!moved && travel > MOVE_THRESHOLD) {
        moved = true;
        root.classList.add('is-dragging');    // disable snap while dragging
        try { track.setPointerCapture(e.pointerId); captured = true; } catch(_) {}
        // Suppress only the next click if we actually dragged
        document.addEventListener('click', (ev) => {
          if (ev.target.closest('a')) { ev.preventDefault(); ev.stopPropagation(); }
        }, { capture: true, once: true });
      }

      const instV = dx / (dt / 16.7);         // px/frame approx
      v = v * 0.8 + instV * 0.2;

      pendingDX += dx;
      lastX = nowX;
      lastT = nowT;
    };

    const onPointerUp = (e) => {
      if (!dragging) return;
      dragging = false;

      if (captured) {
        try { track.releasePointerCapture(e.pointerId); } catch(_) {}
        captured = false;
      }

      if (moved) {
        // keep rAF to finish inertia
        startRAF();
      } else {
        stopRAF();
        root.classList.remove('is-dragging');
      }
    };

    // capture:true so drag can start even over <a>/<img>
    track.addEventListener('pointerdown', onPointerDown, { passive: true,  capture: true });
    track.addEventListener('pointermove', onPointerMove, { passive: true,  capture: true });
    track.addEventListener('pointerup',   onPointerUp,   { passive: true,  capture: true });
    track.addEventListener('pointercancel', onPointerUp, { passive: true,  capture: true });
    track.addEventListener('lostpointercapture', () => { dragging = false; startRAF(); });

    // --- Arrow controls (desktop) ---
    const scrollAmount = () => {
      const styles = getComputedStyle(root);
      const size = parseFloat(styles.getPropertyValue('--size')) || 280;
      const gap  = parseFloat(styles.getPropertyValue('--gap'))  || 20;
      return size + gap;
    };

    const smoothScrollBy = (delta) => {
      root.classList.add('is-dragging'); // disable snap during programmatic scroll
      track.scrollBy({ left: delta, behavior: 'smooth' });
      clearTimeout(smoothScrollBy._t);
      smoothScrollBy._t = setTimeout(() => root.classList.remove('is-dragging'), 360);
    };

    prevBtn?.addEventListener('click', () => smoothScrollBy(-scrollAmount()));
    nextBtn?.addEventListener('click', () => smoothScrollBy( scrollAmount()));
  });
})();
